<template>
	<div class="container">
		<v-btn
			tile
			small
			color="primary"
			text
			:to="{
				name: 'PostDetail'
			}"
			><v-icon>mdi-chevron-left</v-icon> to post</v-btn
		>
		<h2>Amend Additional Categories</h2>
		<v-btn
			tile
			color="secondary"
			@click.prevent="saveChanges"
			:loading="loading"
			>Save Changes</v-btn
		>
		<p v-if="errorMessage !== null">{{ errorMessage }}</p>
		<v-row
			style="background: white; borderRadius: 3px"
			class="my-2 mx-1 pa-4"
		>
			<businessCategoryPicker
				:showSelected="true"
				:existing="existingCategories"
				:radio="false"
				v-model="categories"
				:exclude="primaryCategory"
			/>
		</v-row>
	</div>
</template>

<script>
import businessCategoryPicker from "@/components/businessCategoryPicker.vue";

import { mapGetters } from "vuex";

export default {
	name: "AmendPostCategories",
	components: {
		businessCategoryPicker
	},
	data() {
		return {
			categories: [],
			loading: false,
			errorMessage: null
		};
	},
	async created() {
		if (
			this.loadedPost === null ||
			this.loadedPost.businessId !== this.$route.params.id
		) {
			await this.$store.dispatch(
				"retrievePostByID",
				this.$route.params.id
			);
		}
	},
	computed: {
		...mapGetters(["loadedPost"]),
		existingCategories() {
			return this.loadedPost.categories.map(cat => cat.categoryId);
		},
		primaryCategory() {
			return this.loadedPost.primaryCategory[0].categoryId;
		}
	},
	methods: {
		async saveChanges() {
			this.loading = true;

			const payload = {
				id: this.$route.params.id,
				categories: this.categories
			};

			this.$store
				.dispatch("amendPostAdditionalCategories", payload)
				.then(response => {
					response;
					this.$router.push({
						name: "PostDetail"
					});
				})
				.catch(e => (this.errorMessage = e));

			this.loading = false;
		}
	}
};
</script>